import { Model } from 'types'

export const removeModels = <T extends Model>(
  existingModels: T[] = [],
  removedModels: T[] = [],
) => {
  const updatedModels = existingModels.filter(model => {
    const matchingIndex = removedModels.findIndex(
      newModel => newModel.id === model.id,
    )
    return matchingIndex === -1
  })

  return updatedModels
}
